'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EQUALS = exports.EQUALS = 'EQUALS';
var STARTS_WITH = exports.STARTS_WITH = 'STARTS_WITH';
var CONTAINS = exports.CONTAINS = 'CONTAINS';